import React,{useContext, useState} from 'react';
import settings from '../../settings.json'
import CartContext from './Contexts/CartContext';
import axios from 'axios'
import ImageAspectRatio from './utils/ImageAspectRatio';
// https://engineerbabu.com/blog/how-to-build-an-ecommerce-app/

function CartTableDetail(props) {
    const contextCart = useContext(CartContext)
    const [removItemId, setRemovItemId] = useState(null)
    
    function removeFromCart(id){
        setRemovItemId(id)
        axios.delete(settings.url_api+'/api/carts/'+id+"/", props.header).then((res)=>{
            contextCart.CartDispatch({type:"INIT",payload:res.data})
            setRemovItemId(null)
        }).catch((err)=>{
            console.log("errore, riprova")
            setRemovItemId(null)
        })
    }
    return (
        <>
        <div>
            {props.cart ? props.cart.item.map((variazione,i)=>{ 
                return(
                    <div key={i} className="row cart-blocco-item" key={i}>
                        <div className="col-4">
                            <ImageAspectRatio aspectratio={"3:2"}  src={variazione.item && variazione.item.variationimage_set[0] ? variazione.item.variationimage_set[0].file : "" } alt={variazione && variazione.item.variationimage_set[0] ? variazione.item.variationimage_set[0].alt : ""}></ImageAspectRatio> 
                        </div>
                        <div className="col-8">
                            <div className="cart-titolo"><b>{variazione.item.complete_title}</b></div>
                            <div className="cart-misura"><b className="desc-bold-small">MISURA</b> {variazione.size}</div>
                            <div className="cart-quantita"><b className="desc-bold-small">QUANTITA'</b> {variazione.quantity}</div>
                            <div className="cart-prezzo"><b>
                            {variazione.item.sale_price !== null && variazione.item.validity_for !== null && new Date(variazione.item.validity_for).getTime() > new Date().getTime() ? 
                                ((variazione.item.price - (variazione.item.price * (variazione.item.sale_price / 100))) * variazione.quantity).toFixed(2)
                            :
                            variazione.item.sale_price !== null && variazione.item.validity_for === null ? 
                               ((variazione.item.price - (variazione.item.price * (variazione.item.sale_price / 100))) * variazione.quantity).toFixed(2)
                            :
                                (variazione.item.price * variazione.quantity).toFixed(2)}
                            €</b></div>
                        </div>
                        <div className="col-6">
                            {props.showButton ? 
                                <span onClick={(e)=>{removeFromCart(variazione.id)}} style={{textDecoration:"underline",cursor:"pointer",fontSize:"13px",padding:"10px 0"}}><i className="fa fa-trash-o"></i> Rimuovi</span>
                            :null}
                            </div>
                    </div>
                )
            }) : null}
        </div>
        {/* <div className="d-block d-md-none" style={{textAlign:"left"}}>
        {props.cart ? props.cart.item.map((variazione,i)=>{
                return(
                    <div key={i} className={removItemId === variazione.id ? "row blur-cart" : "row"} style={{borderBottom:"1px solid #E0E0E0",marginBottom:"15px"}}>
                        <div className="col-3">
                                <img src="https://images-na.ssl-images-amazon.com/images/I/61QGGd6ZxXL._AC_UY675_.jpg" style={{width:"100%"}} alt=""/>
                        </div>
                        <div className="col-9 row">
                            <div className="col-12"><b>{variazione.item.title}</b></div>
                            <div className="col-12 row">
                                <div className="col-6">Misura:  {variazione.size}</div>
                                <div className="col-6">Quantity: {variazione.quantity}</div>
                            </div>
                        </div>
                        <div className="col-12 row" style={{padding:"15px"}}>
                            <div className="col-6">
                            {props.showButton ? 
                                <span onClick={(e)=>{removeFromCart(variazione.id)}} style={{textDecoration:"underline",cursor:"pointer",fontSize:"13px",padding:"10px 0"}}><i className="fa fa-trash-o"></i> Rimuovi</span>
                            :null}
                            </div>
                            {variazione.item.sale_price !== null && variazione.item.validity_for !== null && new Date(variazione.item.validity_for).getTime() > new Date().getTime() ? 
                                <div className="col-6" style={{textAlign:"right",fontSize:"18px"}}><b>€{((variazione.item.price - (variazione.item.price * (variazione.item.sale_price / 100))) * variazione.quantity).toFixed(2)}</b></div>
                            :
                            variazione.item.sale_price !== null && variazione.item.validity_for === null ? 
                                <div className="col-6" style={{textAlign:"right",fontSize:"18px"}}><b>€{((variazione.item.price - (variazione.item.price * (variazione.item.sale_price / 100))) * variazione.quantity).toFixed(2)}</b></div>
                            :
                                <div className="col-6" style={{textAlign:"right",fontSize:"18px"}}><b>{(variazione.item.price * variazione.quantity).toFixed(2)} €</b></div>}
                        </div>
                    </div>
                )
        }):null}
        </div>
        <table id="cart" className="table table-hover table-condensed d-none d-md-block">
            <thead>
                <tr>
                    <th style={{width:"10%"}}></th>
                    <th style={{width:"55%",textAlign:"left"}}>Product</th>
                    <th style={{width:"10%"}}>Size</th>
                    <th style={{width:"10%"}}>Quantity</th>
                    <th style={{width:"15%"}} style={{textAlign:"right"}}>Price</th>
                </tr>
            </thead>
            <tbody>
                {props.cart ? props.cart.item.map((variazione,i)=>{
                return(
                    <tr key={i} className={removItemId === variazione.id ? "blur-cart" : ""}>
                        <td className="image-list-cart" style={{width:"10%"}} data-th="">
                            <img src="https://images-na.ssl-images-amazon.com/images/I/61QGGd6ZxXL._AC_UY675_.jpg" style={{width:"100%"}} alt=""/>
                        </td>
                        <td data-th="Product" style={{width:"65%",textAlign:"left"}}>
                            <div className="row">
                                <div className="col-sm-10">
                                    <div><b>{variazione.item.title}</b></div>
                                    <div dangerouslySetInnerHTML={{ __html: variazione.item.subtitle}}/>
                
                                </div>
                            </div>
                            {props.showButton ? 
                                <span onClick={(e)=>{removeFromCart(variazione.id)}} style={{textDecoration:"underline",cursor:"pointer",fontSize:"13px",padding:"10px 0"}}><i className="fa fa-trash-o"></i> Rimuovi</span>
                            :null}
                        </td>
                        <td data-th="Price" style={{textAlign:"center", width:"10%"}}>{variazione.size}</td>
                        <td data-th="Price" style={{textAlign:"center", width:"10%"}}>{variazione.quantity}</td>
                        {variazione.item.sale_price !== null && variazione.item.validity_for !== null && new Date(variazione.item.validity_for).getTime() > new Date().getTime() ? 
                            <td data-th="Price" style={{textAlign:"right" , width:"15%"}}>€{((variazione.item.price - (variazione.item.price * (variazione.item.sale_price / 100))) * variazione.quantity).toFixed(2)}</td>
                        :
                        variazione.item.sale_price !== null && variazione.item.validity_for === null ? 
                            <td data-th="Price" style={{textAlign:"right" , width:"15%"}}>€{((variazione.item.price - (variazione.item.price * (variazione.item.sale_price / 100))) * variazione.quantity).toFixed(2)}</td>
                        :
                            <td data-th="Price" style={{textAlign:"right" , width:"15%"}}>€{(variazione.item.price * variazione.quantity).toFixed(2)}</td>}
                    </tr>
                    )
                }):null}
            </tbody>
        </table> */}
        </>
    );
}

export default CartTableDetail;